import { AdministrationRoutesService } from './administration-routes.service';
import { ClientAdministrationComponent } from './client-administration/client-administration.component';
import { ActivatedRouteSnapshot, RouterModule, RouterStateSnapshot, Routes } from '@angular/router';
import * as pages from '../../core/routing/page-names';
import { UserManagementComponent } from 'src/app/base/user-management/user-management.component';
import { ClientService } from 'src/app/base/services/client/client.service';
import { NgModule, inject } from '@angular/core';
import { RoleService } from 'src/app/base/services/role.service';
import { AdminGuard } from 'src/app/base/guards/admin.guard';
import { UserAdministrationGuard } from 'src/app/base/guards/user-administration.guard';

const routes: Routes = [
  {
    path: pages.administrationPageName,
    resolve: {
      data: () => { return inject(AdministrationRoutesService).initializeNavigationData();}
    },
    children: [
      {
        path: '',
        pathMatch: 'full',
        redirectTo:  pages.clientAdministrationPageName,
      },
      {
        path: pages.clientAdministrationPageName,
        component: ClientAdministrationComponent,
        canActivate: [(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) => inject(AdminGuard).canActivate(route, state)]
      },
      {
        path: pages.userAdministrationPageName,
        component: UserManagementComponent,
        canActivate: [(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) => inject(UserAdministrationGuard).canActivate(route, state)],
        resolve: {
          data: () => { return inject(ClientService).getAccessibleClients();},
          roleInfo:()=>{return inject(RoleService).getRoleMappingInfo();}
        }
      }
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
  providers: [AdministrationRoutesService, AdminGuard, UserAdministrationGuard, ClientService, RoleService]
})
export class AdministrationRoutingModule {}
